"use strict";
import {GlobalParameters} from "generated"
import {Ru} from "./ru.js"
import {En} from "./en.js"

const translations = {
    en: {
        translation: En.translations
    },
    ru: {
        translation: Ru.translations
    }
}
export class TranslateService{
    constructor(){
        this.initTranslate()
    }
    initTranslate() {
        i18next.init(
            {
                fallbackLng: { 
                    'default': ['ru']
                },
                lng: GlobalParameters.globals.Language,
                debug: true,
                resources: translations
            },
        );
    }
}